import script from "./relFuneral.vue?vue&type=script&setup=true&lang=ts"
export * from "./relFuneral.vue?vue&type=script&setup=true&lang=ts"

import "./relFuneral.vue?vue&type=style&index=0&id=7758d9eb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7758d9eb"]])

export default __exports__